import { render, staticRenderFns } from "./accountStatement.vue?vue&type=template&id=266aa667&"
import script from "./accountStatement.vue?vue&type=script&lang=js&"
export * from "./accountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports